<template>
	<div>
		<div v-if="error">
			<slot name="error">{{ error }}</slot>
		</div>
		<slot :content="content">{{ content }}</slot>
	</div>
</template>

<script>
import {VUEX_BUYOUT} from '../../../store/buyout';
import {ACTION_TYPES} from "../../../store/buyout/_action-types";
import {mapActions} from "vuex";

export default {
	name: 'BaseEditorBlock',
	props: {
		identifier: {
			type: String,
			require: true
		},
		type: {
			type: String,
			require: true
		},
		contentAttr: {
			type: String,
			require: true
		}
	},
	data() {
		return {
			content: null,
			error: null
		}
	},
	async created() {
		if (!this.identifier) {
			this.error = this.$t('buyout.error.empty_component');
		} else if (!this.type || !this.contentAttr) {
			this.error = this.$t('buyout.error.no_type_component');
		} else {
			let data = await this[ACTION_TYPES.LOAD_COMPONENT_DATA]({type: this.type, identifier: this.identifier});
			if (data.error) this.error = data.error;
			if(!data.response?.data?.is_active) this.content = 'is_inactive';
			else this.content = data.response?.data?.[this.contentAttr];
		}
	},
	methods:{
		...mapActions(VUEX_BUYOUT.NAMESPACE,[
					ACTION_TYPES.LOAD_COMPONENT_DATA,
		]),
	}
}
</script>
